import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastController, ModalController, IonRouterOutlet  } from '@ionic/angular';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy.page';

@Component({
  selector: 'app-customer-register',
  templateUrl: './customer-register.page.html',
  styleUrls: ['./customer-register.page.scss'],
})

export class CustomerRegisterPage {
  formGroup: FormGroup;
  formManualGroup: FormGroup;
  message = '';
  register_first_form:boolean = true;
  register_manual_form:boolean = false;
  success_page:boolean = false;
  invalidEmail =false;
  acceptPrivacyPolicy = false;

  constructor(
    private _fb: FormBuilder, 
    private _formb: FormBuilder,
    private router:Router, 
    private authService:AuthService,
    public toastController: ToastController,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet
  ) {
    this.formGroup = this._fb.group({
      email: ['', Validators.compose([Validators.required])],
      password: ['',Validators.compose([Validators.required, Validators.pattern("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,20}$")])],
      confirm_password: ['',Validators.compose([Validators.required])],
    });

    this.formManualGroup = this._formb.group({
      first_name: ['',Validators.compose([Validators.required, Validators.maxLength(190)])],
      last_name: ['',Validators.compose([Validators.required, Validators.maxLength(190)])],
      street: ['',Validators.compose([Validators.required, Validators.maxLength(200)])],
      house_number: ['',Validators.compose([Validators.required, Validators.maxLength(100)])],
      zip_code: ['',Validators.compose([Validators.required, Validators.maxLength(30),Validators.pattern('^[0-9]*$')])],
      town: ['',Validators.compose([Validators.required, Validators.maxLength(200)])],
      phone_number: ['',Validators.compose([Validators.required, Validators.maxLength(20)])]
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  get form() {
    return this.formManualGroup.controls;
  }

  onRegisterManual(){
    let register={
      email: this.formGroup.get('email').value.trim().toLowerCase(),
      password: this.formGroup.get('password').value.trim(),
      first_name: this.formManualGroup.get('first_name').value.trim(),
      last_name: this.formManualGroup.get('last_name').value.trim(),
      street: this.formManualGroup.get('street').value.trim(),
      house_number: this.formManualGroup.get('house_number').value.trim(),
      zip_code: this.formManualGroup.get('zip_code').value.trim(),
      town: this.formManualGroup.get('town').value.trim(),
      phone_number: this.formManualGroup.get('phone_number').value.trim(),
    }

    this.authService.registerManual(register).subscribe( 
      response => {
        this.message = response.message;
        this.success_page = true;
        this.register_manual_form = false;
      },
      error => {
        console.log(error);
        this.register_manual_form = true;
        this.success_page = false;
        this.message = error.error.message;
      }
    );  
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  onRegister(){
    let email = this.formGroup.get('email').value.trim().toLowerCase();
    let regexp = new RegExp(/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/);
    regexp.test(email);
    this.invalidEmail =false;
    if (!regexp.test(email)){
      this.invalidEmail =true;
      return false;
    }
    let user={
      email: email,
      password: this.formGroup.get('password').value.trim(),
      confirm_password: this.formGroup.get('confirm_password').value
    }
    this.authService.register(user).subscribe( 
      response => {
        if(response.status == 422){
          this.presentToast(response.error.error.message);
        }else if(response.status == 466){
          this.register_manual_form = true;
          this.success_page = false;
          this.register_first_form = false;
          this.message = response.error.message;
        }else if(response.status == 200){
          this.message = response.message;
          this.success_page = true;
          this.register_manual_form = false;
          this.register_first_form =false;
        }
      },
      error => {
        this.presentToast(error.error.error.message);
      }
    );    
  }

  onloginPage(){
    this.router.navigate(['customer-login']);
  }

  backPage(){
    this.router.navigate(['customer-login']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

  async privacyPolicyPage() {
    console.log("asdfasdf");
    const modal = await this.modalCtrl.create({
      component: PrivacyPolicyPage,
      backdropDismiss: true,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.present();
  }

}
